// extracted by mini-css-extract-plugin
module.exports = {"preloader":"_0fce717cdb--preloader--Xk1OP","spin":"_0fce717cdb--spin--O7jDs"};